import AppService from './AppService';

class PackageService extends AppService {
  constructor() {
    super();
    this.path = this.getPath('admin/packages');
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }

  read(id) {
    return this.http.get(`${this.path}/${id}`);
  }

  create(data) {
    return this.http.post(`${this.path}`, data);
  }

  update(data, id) {
    return this.http.patch(`${this.path}/${id}`, data);
  }

  delete(id) {
    return this.http.delete(`${this.path}/${id}`);
  }

}

export default PackageService;
